module.exports = __webpack_public_path__ + "img/06_chilling_(white).d06ec014.svg";